import React, { useEffect, useState } from "react";
import { About } from "../../../components/Rental/Layout/About";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { useNavigate } from "react-router-dom";
import Axios from "../../../axios/axios";

// ✅ Fetch rental-related data (brands, models, categories)
export const getCompleteRentalData = async (
  setRentalModels,
  setRentalBrands,
  setRentalCategories
) => {
  try {
    const response = await Axios.get("/rental/type-based-details"); // 👈 API endpoint for rental
    console.log("Rental API Response:", response.data);
    setRentalModels(response.data.rental.models || []);
    setRentalBrands(response.data.rental.brands || []);
    setRentalCategories(response.data.rental.categories || []);
  } catch (error) {
    console.error("Error fetching rental details:", error);
  }
};

export const getRentalRegions = async (setRegion) => {
  try {
    const response = await Axios.get("/rental/regions");
    setRegion(response.data || []);
  } catch (error) {
    console.error("Error fetching rental regions:", error);
  }
};

export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 2000 + 1 }, (_, i) => 2000 + i);
};

export const searchRentalItems = async (filters, page = 1, limit = 10) => {
  try {
    const params = new URLSearchParams({ ...filters, page, limit });
    const response = await Axios.post(`/rental/search?${params.toString()}`);
    return response.data || { data: [], total: 0, pages: 0, page };
  } catch (error) {
    console.error("Error fetching rental items:", error);
    return { data: [], total: 0, pages: 0, page };
  }
};

function RentalHome() {
  const [rentalModels, setRentalModels] = useState([]);
  const [rentalBrands, setRentalBrands] = useState([]);
  const [rentalCategories, setRentalCategories] = useState([]);
  const [rentalRegions, setRentalRegions] = useState([]);

  useEffect(() => {
    getCompleteRentalData(
      setRentalModels,
      setRentalBrands,
      setRentalCategories
    );
    getRentalRegions(setRentalRegions);
  }, []);

  return (
    <>
      {/* Rental intro section */}
      <About />

      {/* Later you can display models/brands/categories here
      <div className="container py-4">
        <h2 className="fw-bold text-center mb-4">Rental Marketplace</h2>
        <p className="text-center text-muted">
          Browse rental products by brand, category, and region.
        </p>
      </div> */}
    </>
  );
}

export default RentalHome;
